import { CommonModule, JsonPipe, NgFor, NgIf, DatePipe } from '@angular/common';
import { Component, NgZone, OnInit } from '@angular/core';
import {
  ReactiveFormsModule,
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { PropertyService } from '../../../_services/properties/property.service';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { NumberformatDirective } from '../../../_pipes/numberformat.directive';
import { ViewChild, ElementRef } from '@angular/core';
import { debounceTime, finalize } from 'rxjs';
import { ToastService } from '../../../_services/toast.service';
import { VideoWatermarkService } from '../../../_services/properties/videowatermark.service';

type DropdownKey = 'livingEnvironment' | 'nearbyPlaces';

interface DropdownConfig {
  label: string;
  placeholder: string;
  options: string[];
  multiple: boolean;
  allowNone?: boolean;
}
interface MediaItem {
  url: string;
  type: 'gallery' | 'video' | 'plan';
}

@Component({
  selector: 'app-property',
  standalone: true, // Assuming standalone based on the imports array
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgIf,
    NgFor,
    MatFormFieldModule,
    MatSelectModule,
    NumberformatDirective, RouterModule,
  ],
  templateUrl: './property.component.html',
  styleUrl: './property.component.scss',
})
export class PropertyComponent implements OnInit {
  @ViewChild('fileInput') fileInput!: ElementRef;
  propertyForm:FormGroup;
  openDropdown: DropdownKey | null = null;
  currentStep = 1;
  totalSteps = 5;
  showSuccessModal = false;
  priceUnits = ['K', 'Lacs', 'Cr'];
  propertyTypes = [
    'Apartment',
    'Villa',
    'Villament',
    'Penthouse',
    'Plot / Independent House',
    'Farmhouse',
    'Boutique Apartment',
  ];
  listingTypes = ['Sale', 'Rent', 'Lease', 'Resale'];
  communityCategory = [
    'CXOs Community',
    'Founder-Led Society',
    'UHNI-Dominant Community',
    'Family Business-Led Community',
    'Old Bangalore / Legacy Families',
    'NRI-Heavy Residency',
    'Low-Turnover Private Society',
  ];
  microMarketList:any = []
  propertyStructureType = [
    'Simplex',
    'Duplex',
    'Triplex',
    'Penthouse',
    'Studio Apartment',
    'Constructed',
    '⁠⁠Non-Constructed'
  ];
  livingEnvironment = [
    'Child-Friendly Community',
    'Family-Oriented Society',
    'Low-Density Society',
    'Single Home per Floor',
    'Limited Homes per Block',
    'Low-Density Building',
    'High Privacy Layout',
    'Restricted / Controlled Visitor Access',
    'Secure Gated Access',
    'Quiet Residential Zone',
    'Low Traffic Movement',
  ];
  sellerProfile = [
    'CXO / Senior Leadership',
    'Founder',
    'Family Business Owner',
    'NRI / OCI',
    'Builder / Developer',
    'Professional Investor',
    'Legacy Owner (long-term family ownership)',
  ];
  possessionStatus = [
    'Ready to Move',
    'Under Construction',
    'Not Started',
    'Pre Launch',
    'New Launch',
    'Resale',
    'Upcoming',
    'NA',
  ];
  structureOptions = ['RCC Framed', 'Load Bearing', 'Steel Frame'];
  // nearbyPlaces = [];
  facingDir = [
    'East',
    'West',
    'North',
    'South',
    'North-East',
    'North-West',
    'South-East',
    'South-West',
  ];
  furnishingStatus = ['Furnished', 'Semi-Furnished', 'Unfurnished'];
  parkingAvailability = ['Covered', 'Open', 'NA'];
  parkingCapacity = ['1', '2', '3', '4', '4+'];
  ageOfPropertyList: any = [
    'New Construction',
    'Less than 5 years',
    '5-10 years',
    '10-15 years',
    '15-20 years',
    'Above 20 years',
  ];
  uploadPropertyDetails: any;
  amenities: any = [];
  possessionYear: string[] = [];
  isOpen = false;
  searchText = '';
  allAdditionalRooms: any = [
    'Puja Room',
    'Study Room',
    'Store Room',
    'Servant Room',
    'Media Room',
    'None',
  ];
  bedRoomsCounts = [
    '1 bhk',
    '1.5 bhk',
    '2 bhk',
    '2.5 bhk',
    '3 bhk',
    '3.5 bhk',
    '4 bhk',
    '4.5 bhk',
    '5 bhk',
    '5.5 bhk',
    '6 bhk',
    '6.5 bhk',
    '7 bhk',
    '7.5 bhk',
    '8 bhk',
    '8.5 bhk',
    '9 bhk',
    '9.5 bhk',
    '10+ bhk',
  ];

  readonly dropdownKeys: DropdownKey[] = ['livingEnvironment', 'nearbyPlaces'];
  readonly dropdowns: Record<DropdownKey, DropdownConfig> = {
    livingEnvironment: {
      label: 'Privacy & Living Environment',
      placeholder: 'Select environment',
      options: [
        'Child-Friendly Community',
        'Family-Oriented Society',
        'Low-Density Society',
        'Single Home per Floor',
        'Limited Homes per Block',
        'Low-Density Building',
        'High Privacy Layout',
        'Restricted / Controlled Visitor Access',
        'Secure Gated Access',
        'Quiet Residential Zone',
        'Low Traffic Movement',
      ],
      multiple: true,
    },
    nearbyPlaces: {
      label: 'Near By Places',
      placeholder: 'Select places',
      options: [
        'International School',
        'Metro Station',
        'Railway Station',
        'Hospital',
        'Golf Course',
        'Business District',
        'Tech Park',
        'High Street / Commercial Hub',
        '5 Star Hotels',
        'Bangalore Club',
        'Bowring Institute',
        'Century Club',
        'Bangalore Golf Club',
        'Karnataka Golf Association (KGA)',
        'Prestige Golfshire Club',
        'Eagleton – The Golf Resort',
        'Karnataka State Lawn Tennis Association (KSLTA)',
        'Karnataka State Cricket Association (KSCA) Club',
        'Bangalore Turf Club (BTC)',
        'Army & Navy Club',
        'Indiranagar Club',
        'Koramangala Club',
        'Sadashivanagar Club',
        'The Hoysala Club',
        'The Domlur Club',
        'Jayamahal Palace Club',
        'Bangalore City Institute (BCI Club)',
        'Basavanagudi Union',
        'Windsor Sports Club',
      ],
      multiple: true,
    },
  };
  

  // image upload
  uploadType: 'gallery' | 'plan' | 'video' = 'gallery';
  selectedFiles: File[] = [];
  previews:MediaItem [] = [];
  isDragging = false;
  showUploadSuccessModal = false;
  isEditMode = false;
  propertyId: string | any | null = null;
  
  constructor(
    private fb: FormBuilder,
    private readonly _PS: PropertyService,
    private readonly router: Router,
    private ngZone: NgZone,
    private route: ActivatedRoute,
    private _NS: ToastService,
    private watermarkService: VideoWatermarkService
  ) {
    this.propertyForm = this.fb.group({
      nearbyPlaces: [[]],
      livingEnvironment: [[]],
    });
  }
  progress$:any;
  processing$:any;

  ngOnInit(): void {
    this.getAllMicroMarket()
    this.progress$   = this.watermarkService.progress$;
   this.processing$ = this.watermarkService.processing$;
    this.propertyId = this.route.snapshot.paramMap.get('id');
    this.amenities = this._PS.getAmenities();
    this.possessionYear = this._PS.getYearRange(35);
    this.formControllers();
    this.watchParkingType();
    this.uploadType = 'gallery';
    if (this.propertyId) {
      this.isEditMode = true;
      this.loadPropertyData(this.propertyId);
    }
    this.propertyForm.valueChanges.subscribe((value) => {
      const { basementCount, floorCount } = value;

      if (basementCount !== '' && floorCount >= 0) {
        this.propertyForm
          .get('structure')
          ?.setValue(`${basementCount} G+${floorCount}`, { emitEvent: false });
      } else {
        this.propertyForm.get('structure')?.setValue('', { emitEvent: false });
      }
    });
    this.propertyForm.get('propertyType')?.valueChanges.subscribe((type) => {
      if (type === 'Plot / Independent House') {
        this.pricingRows.controls.forEach((row) => {
          const bhkControl = (row as FormGroup).get('bhkType');
          bhkControl?.clearValidators();
          bhkControl?.setValue('', { emitEvent: false });
          bhkControl?.updateValueAndValidity({ emitEvent: false });
        });
      } else {
        // Restore required validator when switching back from Plot / Independent House
        this.pricingRows.controls.forEach((row) => {
          const bhkControl = (row as FormGroup).get('bhkType');
          bhkControl?.setValidators(Validators.required);
          bhkControl?.updateValueAndValidity({ emitEvent: false });
        });
      }
    });
  }

  formControllers() {
    let currentYear = new Date();
    this.propertyForm = this.fb.group({
      name: ['', Validators.required],
      ageOfProperty: ['New Construction', Validators.required],
      price: this.fb.array([this.createPriceRow()]),
      type: ['', Validators.required],
      propertyType: ['Apartment', Validators.required],
      microMarket: [null, Validators.required],
      sellerProfile: ['', Validators.required],
      communityCategory: ['', Validators.required],
      livingEnvironment: [''],
      nearbyPlaces: [''],
      isLiked: [false],
      isPropertyVerified: [false,Validators.required],
      isExclusive: [false,Validators.required],
      isHighDemand: [false,Validators.required],
      isInvestmentGrade: [false,Validators.required],
      builder: [''],
      address: ['', Validators.required],
      streetName: ['', Validators.required],
      cityName: ['', Validators.required],
      stateName: ['', Validators.required],
      pinCode: ['', Validators.required],
      location: [''],

      // Step 2: Technical Specs
      landArea: [null, [Validators.required, Validators.min(1)]],
      superBuiltUpArea: [null, [Validators.required, Validators.min(1)]],
      possession: ['Ready to Move', Validators.required],
      possessionYear: [currentYear.getFullYear().toString(),Validators.required ],
      structure: ['', Validators.required],
      basementCount: ['', Validators.required],
      floorCount: [
        '',
        [Validators.required, Validators.min(0), Validators.max(100)],
      ],
      facing: ['North-East'],
      additionalRooms: [
        ['Puja Room'],
        [Validators.required, Validators.min(1)],
      ],
      furnishing: ['Semi-Furnished', Validators.required],
      reraNumber: [''],
      parking: ['Open', Validators.required],
      description: ['', Validators.required],
      shortDescription: ['', Validators.required],
      amenities: this.fb.group({}),
      planImage: this.fb.array([]),
      galleryImage: this.fb.array([]),
      propertyVideo: this.fb.array([]),
    });
    this.addAmenitiesControls();
    this.propertyForm.get('propertyType')?.valueChanges.subscribe((res) => {
      if (res != 'Apartment') {
        this.bedRoomsCounts = [
          '1 bhk',
          '1.5 bhk',
          '2 bhk',
          '2.5 bhk',
          '3 bhk',
          '3.5 bhk',
          '4 bhk',
          '4.5 bhk',
          '5 bhk',
          '5.5 bhk',
          '6 bhk',
          '6.5 bhk',
          '7 bhk',
          '7.5 bhk',
          '8 bhk',
          '8.5 bhk',
          '9 bhk',
          '9.5 bhk',
          '10+ bhk',
        ];
      }
    });
    this.propertyForm.get('sellerProfile')?.valueChanges.subscribe((val: string) => {
      this.handleBuilderControl(val);
    });  
  }

  getAllMicroMarket(){
    this._PS.getAllMircoMarketReq().subscribe((_:any)=>{
      this.microMarketList = this.filterDuplicateMicromarkets(_)
      console.log('microMarketList',this.microMarketList)
    })
  }

  filterDuplicateMicromarkets(data:any) {
    const seen = new Set();
    
    return data.filter((item:any) => {
      const key = `${item.micromarketName}`;
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  }
  

  
  handleBuilderControl(value: string) {
    if (value === 'Builder / Developer') {
      if (!this.propertyForm.contains('builder')) {
        this.propertyForm.addControl('builder', this.fb.control('', Validators.required));
      }
    } else {
      if (this.propertyForm.contains('builder')) {
        this.propertyForm.removeControl('builder');
      }
    }
    
    this.propertyForm.updateValueAndValidity();
  }

  editPropertyDetails: any;
  loadPropertyData(id: string) {
    this._PS.getProperty(id).subscribe((res: any) => {
      this.propertyForm.patchValue(res.data);
      this.editPropertyDetails = res.data;
       res.data.galleryImage.forEach((img:any) => {
        this.previews.push({url:img,type:'gallery'})
       });
      this.patchPriceData(res.data.price);

      if (this.editPropertyDetails.galleryImage.length > 0) {
        this.editPropertyDetails.galleryImage.forEach((img: string) => {
          this.galleryImageArray.push(this.fb.control(img));
        });
      }
      if (this.editPropertyDetails.planImage.length > 0) {
        this.editPropertyDetails.planImage.forEach((img: string) => {
          this.planImageArray.push(this.fb.control(img));
        });
      }
      if (this.editPropertyDetails.propertyVideo.length > 0) {
        this.editPropertyDetails.propertyVideo.forEach((img: string) => {
          this.propertyVideoArray.push(this.fb.control(img));
        });
      }
    });
  }
  compareMicroMarket(a: any, b: any): boolean {
    return a && b ? a.micromarketName === b.micromarketName : a === b;
  }
  patchPriceData(priceArray: any[]) {
    const control = this.propertyForm.get('price') as FormArray;
    if (!control) return;
  
    const isPlot = this.propertyForm.get('propertyType')?.value === 'Plot / Independent House';
  
    control.clear();
    priceArray.forEach((item) => {
      const row = this.createPriceRow(); //uses your validator logic
  
      row.patchValue({
        bhkType: isPlot ? null : (item.bhkType?.toLowerCase() ?? ''), //clear if Plot / Independent House
        areaInSq: item?.areaInSq ?? null,
        price: item.price,
        propertyStructureType: item.propertyStructureType,
        averagePrice: item.averagePrice,
      }, { emitEvent: false });
  
      control.push(row);
    });
  }
  addAmenitiesControls() {
    const amenitiesGroup = this.propertyForm.get('amenities') as FormGroup;
    this.amenities.forEach((amenity: any) => {
      amenitiesGroup.addControl(amenity.value, this.fb.control(false));
    });
  }
  get planImageArray() {
    return this.propertyForm.get('planImage') as FormArray;
  }

  get galleryImageArray() {
    return this.propertyForm.get('galleryImage') as FormArray;
  }
  get propertyVideoArray() {
    return this.propertyForm.get('propertyVideo') as FormArray;
  }

  addPlanImage() {
    this.planImageArray.push(this.fb.control('', Validators.required));
  }

  removePlanImage(index: number) {
    this.planImageArray.removeAt(index);
  }
  watchParkingType() {
    this.propertyForm.get('parking')?.valueChanges.subscribe((value) => {
      if (value === 'Covered') {
        this.propertyForm.addControl(
          'parkingCapacity',
          this.fb.control('', [Validators.required, Validators.min(1)])
        );
      } else {
        this.propertyForm.removeControl('parkingCapacity');
      }
    });
  }

  isStepValid(step: number): boolean {
    const fieldsByStep: { [key: number]: string[] } = {
      1: [
        'name',
        'type',
        'microMarket',
        'sellerProfile',
        'communityCategory',
        // 'builder',
        'address',
        'streetName',
        'cityName',
        'stateName',
        'pinCode',
        // 'nearbyMarket',
        // 'nearbySchool',
        // 'nearbyHospital',
      ],
      2: ['propertyType', 'price'],
      3: [
        'landArea',
        'superBuiltUpArea',
        'possession',
        'structure',
        // 'facing',
        // 'bedrooms',
        'furnishing',
        // 'reraNumber',
        'parking',
      ],
      4: ['description', 'shortDescription', 'amenities'],
      5: ['planImage'],
    };

    const fields = fieldsByStep[step];
    return fields.every((field) => this.propertyForm.get(field)?.valid);
  }

  nextStep(): void {
    if (
      this.currentStep < this.totalSteps &&
      this.isStepValid(this.currentStep)
    ) {
      this.currentStep++;
    } else {
      this.markStepFieldsAsTouched(this.currentStep);
    }
  }

  prevStep(): void {
    if (this.currentStep > 1) {
      this.currentStep--;
    }
  }

  markStepFieldsAsTouched(step: number): void {
    const fieldsByStep: { [key: number]: string[] } = {
      1: [
        'name',
        'type',
        'microMarket',
        'sellerProfile',
        'communityCategory',
        // 'builder',
        'address',
        'streetName',
        'cityName',
        'stateName',
        'pinCode',
        // 'nearbyMarket',
        // 'nearbySchool',
        // 'nearbyHospital',
      ],
      2: ['price', 'propertyType'],
      3: [
        'landArea',
        // 'builtUpArea',
        'superBuiltUpArea',
        'possession',
        'structure',
        // 'facing',
        // 'bedrooms',
        'furnishing',
        // 'reraNumber',
        'parking',
      ],
      4: ['description', 'shortDescription', 'amenities'],
      5: ['planImage'],
    };

    fieldsByStep[step].forEach((field) => {
      const control = this.propertyForm.get(field);
      if (control instanceof FormGroup) {
        control.markAllAsTouched();
      } else {
        control?.markAsTouched();
      }
    });
  }
  addPropertyDetails: any;
  onSubmit(): void {
    if (this.propertyForm.valid) {
      const formData = this.propertyForm.value;
      const observer = {
        next: (res: any) => {
          if (res.status) {
            this.resetMediaArrays();
            this.addPropertyDetails = res.data;
            if (!this.isEditMode) this.uploadPropertyDetails = res.data;
            this.showSuccessModal = true;
            this._NS.success(this.isEditMode ? 'Property updated successfully!' : 'Property added successfully!');
          } else {
            // Sometimes APIs return 200 OK but with status: false
            this._NS.error(res.message || 'An unexpected error occurred');
          }
        },
        error: (err: any) => {
          console.error('API Error Object:', err); // Debug this in console!
  
          // Extract the best possible message
          const errorMessage = err.error?.message || err.message || 'Something went wrong';
          
          // Show the notification
          this._NS.error(errorMessage);
        }
      };
  
      if (this.isEditMode) {
        this._PS.updateProperty(this.propertyId, formData).subscribe(observer);
      } else {
        this._PS.addProperty(formData).subscribe(observer);
      }
    } else {
      this.propertyForm.markAllAsTouched();
      this._NS.warning('Please fill all required fields correctly.');
    }
  }
  
  // Helper to keep code clean
  private resetMediaArrays() {
    this.planImageArray.clear();
    this.galleryImageArray.clear();
    this.propertyVideoArray.clear();
    this.uploadMediaRes = [];
  }
  resetForm(): void {
    this.ngOnInit()
    this.currentStep = 1;
    this.showSuccessModal = false;
    this.previews = []
    this.resetMediaArrays()
  }

  navigateToGallery(): void {
    this.showSuccessModal = false;
    this.router.navigate(
      ['admin/property/image-upload', this.uploadPropertyDetails._id],
      {
        queryParams: {
          mode: 'gallery',
        },
      }
    );
  }
  MAX_SELECTION = 3;

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }
  toggleItem(item: string) {
    const control = this.propertyForm.get('additionalRooms');
    let currentValues = control?.value || [];

    if (item === 'None') {
      currentValues = ['None'];
    } else {
      currentValues = currentValues.filter((v: string) => v !== 'None');
      const index = currentValues.indexOf(item);
      if (index > -1) {
        currentValues.splice(index, 1);
      } else {
        currentValues.push(item);
      }
    }

    control?.setValue(currentValues);
    control?.markAsTouched();
  }

  removeRoom(room: string, event: Event) {
    event.stopPropagation();
    const control = this.propertyForm.get('additionalRooms');
    const currentValues = control?.value.filter((v: string) => v !== room);
    control?.setValue(currentValues);
  }

  isItemSelected(item: string): boolean {
    return this.propertyForm.get('additionalRooms')?.value?.includes(item);
  }

  // media center
  setUploadType(type: 'gallery' | 'plan' | 'video') {
    if (this.isUploading) return;
    this.uploadType = type;
    this.clearAll();
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input.files?.length) return;
    this.processFiles(input.files);
    input.value = ''; // allow re-select same file
  }

  onFileDropped(event: DragEvent) {
    event.preventDefault();
    this.isDragging = false;
    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      this.processFiles(files);
      if (this.fileInput) this.fileInput.nativeElement.value = '';
    }
  }

  processFiles(files: FileList) {
    if (this.isUploading) return;
    const filesArray = Array.from(files);
    // Remove window.location.origin. Relative paths are more reliable in Angular.
    const logoSrc = 'assets/logo_watermark.png';

    filesArray.forEach((file) => {
      // 1. Handle Videos
      if (file.type.startsWith('video/')) {
        this.handleVideoFile(file);
        return;
      }
      const reader = new FileReader();
      reader.onload = () => {
        const img = new Image();
        img.src = reader.result as string;

        img.onload = async () => {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          if (!ctx) return;

          canvas.width = img.width;
          canvas.height = img.height;
          ctx.drawImage(img, 0, 0);

          // --- 1. Load and Draw Logo ---
          try {
            const logo = await this.loadLogo(logoSrc);
            const logoWidth = canvas.width * 0.35;
            const logoHeight = (logo.height / logo.width) * logoWidth;
            const xPos = canvas.width / 2 - logoWidth / 2;
            const yPos = canvas.height / 2 - logoHeight / 2;
            ctx.save();
            ctx.globalAlpha = 0.9;
            ctx.drawImage(logo, xPos, yPos, logoWidth, logoHeight);
            ctx.restore();
          } catch (error) {
            // If the logo fails, we log it but continue so the user's image isn't lost
          }

          // --- 2. Draw Text Watermark ---
          const watermarkText = '';
          if (watermarkText) {
            const fontSize = Math.floor(canvas.width * 0.03);
            ctx.save();
            ctx.translate(canvas.width / 2, canvas.height / 2);
            ctx.rotate(-Math.PI / 4);
            ctx.font = `bold ${fontSize}px sans-serif`;
            ctx.fillStyle = 'rgba(255, 255, 255, 0.3)';
            ctx.textAlign = 'center';

            const spacingX = fontSize * 5;
            const spacingY = fontSize * 3;
            for (let x = -canvas.width; x < canvas.width; x += spacingX) {
              for (let y = -canvas.height; y < canvas.height; y += spacingY) {
                ctx.fillText(watermarkText, x, y);
              }
            }
            ctx.restore();
          }

          this.finalizeCanvas(canvas, file);
        };
      };
      reader.readAsDataURL(file);
    });
  }

  private loadLogo(src: string): Promise<HTMLImageElement> {
    return new Promise((resolve, reject) => {
      const logo = new Image();
      // Setting crossOrigin before src helps avoid canvas tainting
      logo.crossOrigin = 'anonymous';
      logo.onload = () => resolve(logo);
      logo.onerror = () => reject(new Error(`Could not load image at ${src}`));
      logo.src = src;
    });
  }

  private finalizeCanvas(canvas: HTMLCanvasElement, file: File) {
    const previewUrl = canvas.toDataURL(file.type);
    canvas.toBlob((blob) => {
      if (!blob) return;
      const watermarkedFile = new File([blob], file.name, { type: file.type });
      this.ngZone.run(() => {
        // Append to previews regardless of type
        this.previews.push({ url: previewUrl, type: this.uploadType });
        this.selectedFiles = [...this.selectedFiles, watermarkedFile];
      });
    }, file.type);
  }

  async handleVideoFile(file: File) {
    console.log(file)
    const videoUrl = URL.createObjectURL(file);
    this.ngZone.run(() => this.updateState(file, videoUrl));
  }
  private updateState(file: File, preview: string) {
    this.ngZone.run(() => {
      this.previews.push({ url: preview, type: this.uploadType });
      this.selectedFiles = [...this.selectedFiles, file];
    });
  }

  removeImage(index: number) {
    this.selectedFiles.splice(index, 1);
    this.previews.splice(index, 1);
  }


  removeImageFromUI(imageUrl: string, imageType: 'planImage' | 'galleryImage' | 'propertyVideo') {
    const formArray = this.propertyForm.get(imageType) as FormArray;
    if (formArray) {
      const index = formArray.controls.findIndex(control => control.value === imageUrl);
      if (index !== -1) {
        formArray.removeAt(index);
      }
    }
    this.previews = this.previews.filter((img: any) => {
      const path = typeof img === 'string' ? img : img.url;
      return path !== imageUrl;
    });
  }

  clearAll() {
    this.selectedFiles = [];
    // this.previews = [];
  }
  uploadMediaRes:MediaItem[]=[]
  isUploading = false;

  uploadImages() {
    if (this.isUploading || this.selectedFiles.length === 0) return;
    this.isUploading = true;
    const formData = new FormData();
    this.selectedFiles.forEach((file: File) => {
      formData.append('files', file, file.name);
    });
    this.showUploadSuccessModal = false;
    let imgData = {
      name: this.propertyForm.value.name,
      type: this.uploadType,
      files: formData,
    };
    this._PS.addPropertyImgAt(imgData).pipe(
      finalize(() => { this.isUploading = false; }),
    ).subscribe({
      next: (res) => {
        if (res.status) {
          if (this.uploadType === 'gallery') {
            res.data.forEach((img: string) => {
              this.uploadMediaRes.push({ url:img, type: 'gallery' })
              this.galleryImageArray.push(this.fb.control(img));
            });
            this.showUploadSuccessModal = true;
          } else if (this.uploadType === 'plan') {
            res.data.forEach((img: string) => {
              this.uploadMediaRes.push({ url:img, type: 'plan' })
              this.planImageArray.push(this.fb.control(img));
            });
            this.showUploadSuccessModal = true;

          } else {
            res.data.forEach((video: string) => {
              this.uploadMediaRes.push({ url:video, type: 'plan' })
              this.propertyVideoArray.push(this.fb.control(video));
            });
            this.showUploadSuccessModal = true;
          }
          this.uploadType = this.uploadType; // Store for the modal text
          this.clearAll(); // Clear current selection/previews
        } else{
          this._NS.error(res.message)
        }
      },
      error: (err) => {
        this._NS.error(err)
      },
    });
  }
  gotoProprty() {
    this.resetForm();
    this.router.navigate(['admin/property']);
  }
  get pricingRows() {
    return this.propertyForm.get('price') as FormArray;
  }
  createPriceRow(): FormGroup {
    const row = this.fb.group({
      bhkType: ['', Validators.required],  // validator toggled dynamically
      areaInSq: ['', [Validators.required, Validators.min(0)]],
      price: ['', [Validators.required, Validators.min(0)]],
      averagePrice: ['', [Validators.required, Validators.min(0)]],
      propertyStructureType: ['Simplex', Validators.required]
    });
  
    // Apply correct validator state immediately on row creation
    this.updateBhkValidator(row);
   // Re-apply whenever propertyType changes
    this.propertyForm.get('propertyType')?.valueChanges.subscribe(() => {
      this.updateBhkValidator(row);
    });
    let lastManualChange = '';
    row.get('price')?.valueChanges.subscribe(() => lastManualChange = 'price');
    row.get('averagePrice')?.valueChanges.subscribe(() => lastManualChange = 'averagePrice');
    row.get('areaInSq')?.valueChanges.subscribe(() => lastManualChange = 'areaInSq');
    row.valueChanges.pipe(debounceTime(300)).subscribe((val: any) => {
      const X = parseFloat(val.price) || 0;
      const Y = parseFloat(val.averagePrice) || 0;
      const Z = parseFloat(val.areaInSq) || 0;
      let update: any = {};
  
      if (lastManualChange === 'price') {
        if (Z > 0) update.averagePrice = Number((X / Z).toFixed(2));
        else if (Y > 0) update.areaInSq = Number((X / Y).toFixed(2));
      } else if (lastManualChange === 'averagePrice') {
        if (Z > 0) update.price = Number((Y * Z).toFixed(2));
        else if (X > 0) update.areaInSq = Number((X / Y).toFixed(2));
      } else if (lastManualChange === 'areaInSq') {
        if (Y > 0) update.price = Number((Y * Z).toFixed(2));
        else if (X > 0) update.averagePrice = Number((X / Z).toFixed(2));
      }
  
      if (Object.keys(update).length > 0) {
        const key = Object.keys(update)[0];
        if (row.get(key)?.value != update[key]) {
          row.patchValue(update, { emitEvent: false });
        }
      }
    });
  
    return row;
  }
  
  // Helper to toggle bhkType validator based on propertyType
  updateBhkValidator(row: FormGroup) {
    const isPlot = this.propertyForm.get('propertyType')?.value === 'Plot / Independent House';
    const bhkControl = row.get('bhkType');
    if (isPlot) {
      bhkControl?.clearValidators();
      bhkControl?.setValue('', { emitEvent: false }); // ← clear value here too
    } else {
      bhkControl?.setValidators(Validators.required);
    }
    bhkControl?.updateValueAndValidity({ emitEvent: false });
  }

  addNewRow() {
    this.pricingRows.push(this.createPriceRow());
  }

  // Remove a specific row
  removeRow(index: number) {
    if (this.pricingRows.length > 1) {
      this.pricingRows.removeAt(index);
    }
  }
  goToPropertyDetails(id: any) {
    this.router.navigate(['admin/property/details'], {
      queryParams: {
        id: id,
        mode: 'details',
      },
    });
  }

  toggleDdown(key: DropdownKey) {
    this.openDropdown = this.openDropdown === key ? null : key;
  }

  isOpens(key: DropdownKey): boolean {
    return this.openDropdown === key;
  }
  toggleItems(item: string, key: DropdownKey) {
    const control = this.propertyForm.get(key);
    const config = this.dropdowns[key];
    if (!control) return;

    let values: string[] = control.value || [];

    // MULTI SELECT DROPDOWN
    if (config.multiple) {

      // If "None" selected → reset everything
      if (config.allowNone && item === 'None') {
        control.setValue(['None']);
        control.markAsTouched();
        return;
      }

      // Remove "None" if real item selected
      if (config.allowNone) {
        values = values.filter(v => v !== 'None');
      }

      const alreadySelected = values.includes(item);

      // Remove if already selected
      if (alreadySelected) {
        values = values.filter(v => v !== item);
      } 
      else {
        //  LIMIT TO 3 SELECTIONS
        if (values.length >= this.MAX_SELECTION) {
          return; // optional toast/snackbar here
        }
        values.push(item);
      }

    } 
    // SINGLE SELECT DROPDOWN
    else {
      values = [item];
      this.openDropdown = null;
    }

    control.setValue(values);
    control.markAsTouched();
  }
  isSelected(item: string, key: DropdownKey): boolean {
    const control = this.propertyForm.get(key);
    const values: string[] = control?.value || [];
    return values.includes(item);
  }
  // toggleDdown(key: DropdownKey) {
  //   this.openDropdown = this.openDropdown === key ? null : key;
  // }

  // isOpens(key: DropdownKey): boolean {
  //   return this.openDropdown === key;
  // }
  // toggleItems(item: string, key: DropdownKey) {
  //   const control = this.propertyForm.get(key);
  //   const config = this.dropdowns[key];
  //   if (!control) return;

  //   let values: string[] = control.value || [];

  //   if (config.multiple) {
  //     if (config.allowNone && item === 'None') {
  //       values = ['None'];
  //     } else {
  //       if (config.allowNone) {
  //         values = values.filter((v) => v !== 'None');
  //       }
  //       const index = values.indexOf(item);
  //       index > -1 ? values.splice(index, 1) : values.push(item);
  //     }
  //   } else {
  //     values = [item];
  //     this.openDropdown = null;
  //   }

  //   control.setValue(values);
  //   control.markAsTouched();
  // }

  // isSelected(item: string, key: DropdownKey): boolean {
  //   return this.propertyForm.get(key)?.value?.includes(item);
  // }

  removeItem(item: string, event: Event, key: DropdownKey) {
    event.stopPropagation();
    const control = this.propertyForm.get(key);
    if (!control) return;

    const values = (control.value || []).filter((v: string) => v !== item);
    control.setValue(values);
  }
}
